export const LABELS = {
	pageTitle: "Text Editor",
	scopeAdmin: "Admin UI",
	scopeHomepage: "Landing & Order",
	scopeStations: "Stations",

	toolbarSearch: "Search keys or text…",
	toolbarFindReplace: "Find / Replace",
	toolbarBulkActions: "Bulk actions",
	toolbarRefresh: "Refresh",
	toolbarSaveDraft: "Save Draft",
	toolbarPublish: "Publish",
	toolbarGlossary: "Glossary",

	filterScreen: "Screen",
	filterGroup: "Group",
	filterTag: "Tag",
	filterStatus: "Status",
	filterAll: "All",

	colKey: "Key",
	colScreen: "Screen",
	colGroup: "Group",
	colText: "English",
	colTextVi: "Tiếng Việt",
	/** Tên hiển thị theo mã ngôn ngữ; mã lạ thì hiện mã in hoa. */
	langName: (code: string) =>
		((
			{
				vi: "Tiếng Việt",
				en: "English",
				kr: "한국어",
				ko: "한국어",
				th: "ไทย",
				ja: "日本語",
				zh: "中文",
			} as Record<string, string>
		)[code] || code.toUpperCase()),
	filterVi: "Vietnamese",
	filterLang: "Language",
	filterViMissing: "Missing",
	filterViPresent: "Translated",
	drawerTextEn: "English (current text)",
	drawerTextVi: "Tiếng Việt",
	drawerTextViHint: "Empty = station sees the English text.",
	viMissingHint: "Chưa dịch — trạm chọn VI sẽ thấy tiếng Anh",
	colTags: "Tags",
	colStatus: "Status",
	colUpdated: "Updated",

	drawerStyleTab: "Style",
	drawerHistoryTab: "History",
	drawerContextTab: "Context",
	drawerValidationTab: "Validation",

	saveDraftSuccess: "Draft saved successfully.",
	saveDraftError: "Failed to save draft.",
	publishSuccess: "Published successfully.",
	publishError: "Failed to publish.",
	revertSuccess: "Entry reverted to selected version.",
	revertError: "Failed to revert entry.",
	publishSelectedSuccess: "Selected keys published.",
	publishSelectedError: "Failed to publish selected keys.",

	publishConfirmTitle: "Publish text live?",
	publishConfirmBody: (scope: string) =>
		`This will publish all draft changes for the "${scope}" scope to production.`,
	publishConfirmOk: "Publish",
	publishConfirmCancel: "Cancel",

	bulkApplyStyle: "Apply style",
	bulkAddTag: "Add tag",
	bulkRemoveTag: "Remove tag",
	bulkPublishSelected: "Publish selected",
	bulkClear: "Clear selection",
	bulkSelected: (n: number) => `${n} row${n !== 1 ? "s" : ""} selected`,

	detectionInboxTitle: "Detection Inbox",
	detectionAdd: "Add to registry",
	detectionIgnore: "Ignore",
	detectionNoneNew: "No new detections.",
	bulkAddBtn: (n: number) => `Add all ${n} with defaults`,
	bulkAddConfirmTitle: "Add all detections?",
	bulkAddConfirmBody: (n: number) =>
		`Add ${n} detection${
			n !== 1 ? "s" : ""
		} to the registry using their suggested screen and group? This cannot be undone before publish.`,
	bulkAddProgress: (done: number, total: number) => `Adding ${done} / ${total} …`,
	bulkAddConfirmOk: "Add all",
	bulkAddConfirmCancel: "Cancel",

	glossaryTitle: "Glossary",
	glossaryAddTerm: "Add term",
	glossaryTermLabel: "Term",
	glossaryCanonicalLabel: "Canonical",
	glossaryNotesLabel: "Notes",
	glossarySeverityLabel: "Severity",
	glossaryDelete: "Delete",
	glossarySave: "Save",
	glossaryCancel: "Cancel",
	glossaryEmpty: "No glossary terms yet.",

	historyNoVersions: "No history yet. History appears after first publish.",
	historyRevert: "Revert to this",
	historyRevertConfirm: "Apply this version to the current draft?",

	contextViewOnSite: "View on site",
	contextNoUrl: "No preview URL available for this key.",

	validationNoIssues: "No validation issues.",
	validationErrors: "Errors",
	validationWarnings: "Warnings",

	emptyStateTitle: "No entries found",
	emptyStateBody: "Try adjusting your filters or adding entries via the Detection Inbox.",

	addToRegistryTitle: "Add detection to registry",
	addToRegistryScreen: "Screen",
	addToRegistryGroup: "Group",
	addToRegistryTags: "Tags (comma-separated)",
	addToRegistryConfirm: "Add",
	addToRegistryCancel: "Cancel",

	findReplaceTitle: "Find & Replace",
	findLabel: "Find",
	replaceLabel: "Replace with",
	matchMode: "Match mode",
	matchSubstring: "Substring",
	matchWholeWord: "Whole word",
	matchRegex: "Regular expression",
	scopeAll: "All entries",
	scopeScreen: "Current screen",
	scopeGroup: "Current group",
	scopeSelected: "Selected rows",
	matchPreview: (n: number, k: number) => `${n} match${n !== 1 ? "es" : ""} across ${k} key${k !== 1 ? "s" : ""}`,
	applyFindReplace: "Apply",
	cancelFindReplace: "Cancel",
};
